<template>
  <div class="text-file-selector">
    <p class="direction">
      {{ "datalink.dragAndDrop" | t }}
    </p>
    <p class="or">
      {{ "datalink.or" | t }}
    </p>
    <label for="fileUpload" class="button is-primary upload-button">
      {{ "datalink.selectFiles" | t }}
      <input
        id="fileUpload"
        type="file"
        style="display: none"
        multiple
        accept="text/csv, application/pdf, text/json"
        @change="onChanged"
      />
    </label>
  </div>
</template>

<script>
export default {
  methods: {
    onChanged(event) {
      const selectedFiles = [];
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        selectedFiles.push(files[i]);
      }
      this.$emit("fileSelected", selectedFiles);
    },
  },
};
</script>

<style scoped lang="scss">
.text-file-selector {
  padding: 34px;

  .direction,
  .or {
    font-size: 16px;
  }

  .upload-button {
    width: 225px;
    height: 50px;
    margin: 20px;
    font-size: 16px;
  }

  .box-footer {
    color: $gray-500;
    font-size: 16px;
  }
}
</style>
